// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import PreviewImage from "../../../../ExternalLib/PreviewImage/PreviewImage.jsx";
// import { useSelector } from "react-redux";
// import { FaAngleDown } from "react-icons/fa";
// const UserDropdown = ({ onLogout }) => {
//     const loggedInUser = JSON.parse(sessionStorage.getItem("loggedInUser"));
//     const { profileDetails } = useSelector((state) => state.OrgProfile);
//     const [showDropdown, setShowDropdown] = useState(false);
//     const toggleDropdown = () => setShowDropdown(!showDropdown);
//     return (
//         <ul className="navbar-nav navbar-nav-icons flex-row">
//             <li className="nav-item dropdown" onMouseLeave={toggleDropdown}>
//                 <a
//                     className="nav-link lh-1 pe-0 white-space-nowrap"
//                     href="#!"
//                     role="button"
//                     onClick={toggleDropdown}
//                     onMouseEnter={toggleDropdown}
//                 >
//                     {loggedInUser?.DisplayName}
//                     <p>
//                         <strong className="text-bolder">({loggedInUser?.AssociateCode})</strong>
//                         <FaAngleDown />
//                     </p>
//                 </a>
//                 {showDropdown && (
//                     <div className="dropdown-menu dropdown-menu-end navbar-dropdown-caret py-0 dropdown-profile shadow border show ">
//                         <div className="card position-relative border-0">
//                             <div className="card-body p-0">
//                                 <div className="text-center pt-4 pb-3">
//                                     <div className="avatar avatar-xl rounded-circle">
//                                         <PreviewImage
//                                             style={{ borderRadius: "50%", height: "50px", width: "50px" }}
//                                             imgwithUrl={profileDetails?.ProfileImage}
//                                         />
//                                     </div>
//                                     <h6 className="mt-2 text-body-emphasis">{loggedInUser?.DisplayName}</h6>
//                                 </div>
//                             </div>
//                             <div className="overflow-auto scrollbar">
//                                 <ul className="nav d-flex flex-column mb-2 pb-1">
//                                     <li onClick={toggleDropdown} className="nav-item">
//                                         <Link onClick={toggleDropdown} className="nav-link px-3 d-block text-body-highlight" to="/profile">
//                                             <span className="me-2 align-bottom" data-feather="user" /> Profile
//                                         </Link>
//                                     </li>
//                                 </ul>
//                             </div>
//                             <div className="card-footer p-0 border-top border-translucent">
//                                 <div className="px-3">
//                                     <button
//                                         className="btn btn-phoenix-secondary d-flex flex-center w-100"
//                                         onClick={onLogout}>
//                                         <span className="me-2" data-feather="log-out" /> Logout
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 )}
//             </li>
//         </ul>
//     );
// };

// export default UserDropdown;



import React, { useState } from "react";

import { Link } from "react-router-dom";
import PreviewImage from "../../../../ExternalLib/PreviewImage/PreviewImage.jsx";
import { useSelector } from "react-redux";
import { FaAngleDown } from "react-icons/fa";

const UserDropdown = ({ onLogout }) => {
    const { profileDetails } = useSelector((state) => state.OrgProfile);
    const [showDropdown, setShowDropdown] = useState(false);

    const toggleDropdown = () => setShowDropdown(!showDropdown);

    return (
        <ul className="navbar-nav navbar-nav-icons flex-row">
            <li className="nav-item dropdown"  >
                {/* Toggle button */}
                <a
                    className="nav-link lh-1 pe-0 white-space-nowrap"
                    // style={{ color: "var(--nav-color)" }}
                    href="#!"
                    role="button"
                    onClick={toggleDropdown} // ✅ use state toggle instead of bootstrap
                    onMouseEnter={() => setShowDropdown(true)}
                >
                    xyz
                    <div>
                        <strong className="text-bolder">
                            (abcd)
                        </strong>
                        <FaAngleDown />
                    </div>
                </a>
                {/* Dropdown */}
                {showDropdown && (
                    <div onMouseLeave={() => setShowDropdown(false)} className="dropdown-menu dropdown-menu-end navbar-dropdown-caret py-0 dropdown-profile shadow border show">
                        <div className=" border-0 shadow-sm rounded-4 overflow-hidden">
                            {/* Profile Header */}
                            <div className="d-flex align-items-center justify-content-start  pt-4 pb-3 bg-light-subtle">
                                {/* Avatar */}
                                <div className="me-3">
                                    <PreviewImage
                                        style={{
                                            height: "56px",
                                            width: "56px",
                                            borderRadius: "4px",
                                            objectFit: "cover",
                                        }}
                                        imgwithUrl={profileDetails?.ProfileImage}
                                    />
                                </div>

                                {/* Name + Role */}
                                <div className="text-start">
                                    <div className="fw-semibold text-dark fs-8">
                                        {xyz}
                                    </div>
                                    <div className="text-muted  mt-1">
                                        Associate ID:{" "}
                                        <span className="fw-semibold badge fs-9 bg-primary-subtle text-primary">
                                            #{bcd}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {/* Divider */}
                            <hr className="my-0" />

                            {/* Navigation */}
                            <ul className=" list-group  rounded-0">
                                <li className="list-group-item py-0">
                                    <Link
                                        onClick={toggleDropdown}
                                        to="/profile"
                                        className="nav-link   text-dark d-flex align-items-center gap-2"
                                    >
                                        <i className="bi ms-1 bi-person-fill text-secondary" />{" "}
                                        Profile
                                    </Link>
                                </li>

                                {/* Logout */}
                                <div className="border-top px-4 py-2 bg-light-subtle">
                                    <button
                                        className="btn btn-outline-danger w-100 d-flex align-items-center justify-content-center gap-2"
                                        onClick={onLogout}
                                    >
                                        <i className="bi bi-box-arrow-right" />
                                        Logout
                                    </button>
                                </div>
                            </ul>
                        </div>
                    </div>
                )}
            </li>
        </ul>
    );
};

export default UserDropdown;

